import { render, staticRenderFns } from "./predictionitem.vue?vue&type=template&id=08d30012&scoped=true&"
import script from "./predictionitem.vue?vue&type=script&lang=js&"
export * from "./predictionitem.vue?vue&type=script&lang=js&"
import style0 from "./predictionitem.vue?vue&type=style&index=0&id=08d30012&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d30012",
  null
  
)

export default component.exports